import type { SVGProps } from 'react'
const SvgOcrRejectedPage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="143"
    height="85"
    viewBox="0 0 143 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_18589_4151)">
      <path
        d="M142.223 79.1489H0.000366211V79.2093H142.223V79.1489Z"
        fill="#F7F7F7"
      />
      <path
        d="M127.971 83.0369H118.55V83.0972H127.971V83.0369Z"
        fill="#F7F7F7"
      />
      <path
        d="M94.2135 83.6929H91.7417V83.7533H94.2135V83.6929Z"
        fill="#F7F7F7"
      />
      <path
        d="M118.267 80.7963H112.809V80.8566H118.267V80.7963Z"
        fill="#F7F7F7"
      />
      <path
        d="M27.2073 81.2017H14.9221V81.262H27.2073V81.2017Z"
        fill="#F7F7F7"
      />
      <path d="M31.543 81.2017H29.7424V81.262H31.543V81.2017Z" fill="#F7F7F7" />
      <path
        d="M64.0435 82.2188H37.3967V82.2791H64.0435V82.2188Z"
        fill="#F7F7F7"
      />
      <path
        d="M67.415 68.3795H12.4888C11.5928 68.3795 10.8646 67.7612 10.8646 67.0004V1.44212C10.8646 0.681303 11.5928 0.0629883 12.4888 0.0629883H67.415C68.311 0.0629883 69.0392 0.681303 69.0392 1.44212V67.0004C69.0392 67.7612 68.311 68.3795 67.415 68.3795ZM12.4888 0.123371C11.6326 0.123371 10.9357 0.715117 10.9357 1.44212V67.0004C10.9357 67.7274 11.6326 68.3192 12.4888 68.3192H67.415C68.2712 68.3192 68.9681 67.7274 68.9681 67.0004V1.44212C68.9681 0.715117 68.2712 0.123371 67.415 0.123371H12.4888Z"
        fill="#F7F7F7"
      />
      <path
        d="M128.941 68.3795H74.0144C73.1184 68.3795 72.3903 67.7612 72.3903 67.0004V1.44212C72.3903 0.681303 73.1184 0.0629883 74.0144 0.0629883H128.941C129.837 0.0629883 130.565 0.681303 130.565 1.44212V67.0004C130.565 67.7612 129.837 68.3795 128.941 68.3795ZM74.0144 0.123371C73.1583 0.123371 72.4614 0.715117 72.4614 1.44212V67.0004C72.4614 67.7274 73.1583 68.3192 74.0144 68.3192H128.941C129.797 68.3192 130.494 67.7274 130.494 67.0004V1.44212C130.494 0.715117 129.797 0.123371 128.941 0.123371H74.0144Z"
        fill="#F7F7F7"
      />
      <path
        d="M71.1121 83.9337C101.571 83.9337 126.263 82.4773 126.263 80.6807C126.263 78.8841 101.571 77.4277 71.1121 77.4277C40.6531 77.4277 15.9612 78.8841 15.9612 80.6807C15.9612 82.4773 40.6531 83.9337 71.1121 83.9337Z"
        fill="#E6F2FE"
      />
      <path
        d="M118.446 7.96973H23.7772C21.4506 7.96973 19.5646 9.87515 19.5646 12.2256V73.3742C19.5646 75.7246 21.4506 77.6301 23.7772 77.6301H118.446C120.773 77.6301 122.659 75.7246 122.659 73.3742V12.2256C122.659 9.87515 120.773 7.96973 118.446 7.96973Z"
        fill="white"
      />
      <path
        d="M118.447 77.7856H23.7778C21.3714 77.7856 19.4116 75.8057 19.4116 73.3746V12.226C19.4116 9.79489 21.3714 7.81494 23.7778 7.81494H118.449C120.856 7.81494 122.816 9.79489 122.816 12.226V73.3746C122.816 75.8057 120.856 77.7856 118.449 77.7856H118.447ZM23.7778 8.1253C21.5393 8.1253 19.7188 9.96444 19.7188 12.226V73.3746C19.7188 75.6361 21.5393 77.4753 23.7778 77.4753H118.449C120.688 77.4753 122.508 75.6361 122.508 73.3746V12.226C122.508 9.96444 120.688 8.1253 118.449 8.1253H23.7778Z"
        fill="#66B0F6"
      />
      <path
        d="M27.7099 12.4492C27.7099 13.2079 27.1012 13.82 26.3531 13.82C25.605 13.82 24.9963 13.205 24.9963 12.4492C24.9963 11.6935 25.605 11.0785 26.3531 11.0785C27.1012 11.0785 27.7099 11.6935 27.7099 12.4492Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M36.6252 13.2532H29.9635C29.5255 13.2532 29.1699 12.8911 29.1699 12.4514C29.1699 12.0089 29.5283 11.6497 29.9635 11.6497H36.6252C37.0632 11.6497 37.4188 12.0117 37.4188 12.4514C37.4188 12.894 37.0604 13.2532 36.6252 13.2532Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M68.7395 12.8902H64.0661C63.8243 12.8902 63.6309 12.6919 63.6309 12.4505C63.6309 12.2063 63.8271 12.0109 64.0661 12.0109H68.7395C68.9813 12.0109 69.1747 12.2091 69.1747 12.4505C69.1747 12.6948 68.9784 12.8902 68.7395 12.8902Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M79.2259 12.8902H74.5525C74.3107 12.8902 74.1173 12.6919 74.1173 12.4505C74.1173 12.2063 74.3136 12.0109 74.5525 12.0109H79.2259C79.4677 12.0109 79.6611 12.2091 79.6611 12.4505C79.6611 12.6948 79.4649 12.8902 79.2259 12.8902Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M89.7142 12.8902H85.0408C84.799 12.8902 84.6056 12.6919 84.6056 12.4505C84.6056 12.2063 84.8019 12.0109 85.0408 12.0109H89.7142C89.956 12.0109 90.1494 12.2091 90.1494 12.4505C90.1494 12.6948 89.9531 12.8902 89.7142 12.8902Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M100.204 12.8902H95.531C95.2892 12.8902 95.0958 12.6919 95.0958 12.4505C95.0958 12.2063 95.2921 12.0109 95.531 12.0109H100.204C100.446 12.0109 100.64 12.2091 100.64 12.4505C100.64 12.6948 100.443 12.8902 100.204 12.8902Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.7"
        d="M113.626 13.2273H106.555C106.131 13.2273 105.787 12.8796 105.787 12.4514C105.787 12.0232 106.131 11.6755 106.555 11.6755H113.626C114.05 11.6755 114.394 12.0232 114.394 12.4514C114.394 12.8796 114.05 13.2273 113.626 13.2273Z"
        fill="#C8C8C8"
      />
      <path
        d="M110.279 21.9808L32.7339 21.9388C29.6448 21.9371 27.1187 22.0991 27.0917 22.3006L26.2293 28.735C26.2023 28.9365 28.6846 29.1012 31.7736 29.1029L109.319 29.1449C112.408 29.1466 114.934 28.9846 114.961 28.7831L115.824 22.3487C115.851 22.1472 113.369 21.9825 110.279 21.9808Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 30.2607L32.7339 30.2187C29.6448 30.2171 27.1187 30.379 27.0917 30.5805L26.2293 37.015C26.2023 37.2165 28.6846 37.3812 31.7736 37.3828L109.319 37.4248C112.408 37.4265 114.934 37.2645 114.961 37.063L115.824 30.6286C115.851 30.4271 113.369 30.2624 110.279 30.2607Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 38.5406L32.7339 38.4986C29.6448 38.497 27.1187 38.659 27.0917 38.8605L26.2293 45.2949C26.2023 45.4964 28.6846 45.6611 31.7736 45.6627L109.319 45.7047C112.408 45.7064 114.934 45.5444 114.961 45.3429L115.824 38.9085C115.851 38.707 113.369 38.5423 110.279 38.5406Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 46.8204L32.7339 46.7784C29.6448 46.7767 27.1187 46.9387 27.0917 47.1402L26.2293 53.5746C26.2023 53.7761 28.6846 53.9408 31.7736 53.9425L109.319 53.9845C112.408 53.9862 114.934 53.8242 114.961 53.6227L115.824 47.1883C115.851 46.9868 113.369 46.822 110.279 46.8204Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 55.1003L32.7339 55.0583C29.6448 55.0567 27.1187 55.2186 27.0917 55.4201L26.2293 61.8546C26.2023 62.0561 28.6846 62.2208 31.7736 62.2224L109.319 62.2644C112.408 62.2661 114.934 62.1041 114.961 61.9026L115.824 55.4682C115.851 55.2667 113.369 55.102 110.279 55.1003Z"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_18589_4151">
        <rect width="142.222" height="84.2012" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgOcrRejectedPage
